import { Row } from "@tanstack/react-table";

import { Button } from "@/components/ui/button";

import { useDialogModal } from "@/hook/handle-modal/hooks/actions";
import { QueryReviewModal } from "../edit";
import { useParams } from "react-router-dom";
import { useEffect } from "react";

interface DataTableRowActionsProps<TData> {
  row: Row<TData>;
}

export function DataTableRowActions<TData>({
  row,
}: DataTableRowActionsProps<TData>) {
  const { id } = useParams<{ id: string }>();
  const { handleModal } = useDialogModal();

  useEffect(() => {
    if (id) {
      handleModal({
        isOpen: true,
        element: (
          <QueryReviewModal
            queryId={id}
            onClose={() => handleModal({ isOpen: false })}
          />
        ),
        title: "Verificação de Query",
      });
      const url = new URL(window.location.href);
      url.searchParams.delete("id");
      window.history.replaceState(null, "", url.toString());
    }
  }, [id, handleModal]);

  const handleOpenModal = () => {
    handleModal({
      isOpen: true,
      element: (
        <QueryReviewModal
          queryId={(row.original as any)?.id}
          onClose={() => handleModal({ isOpen: false })}
        />
      ),
      title: "Verificação de Query",
    });

  };

  return (
    <div className="flex items-center justify-center">
      <Button
        variant="ghost_none"
        onClick={() => handleOpenModal()}
        className="flex px-4 p-0 data-[state=open]:bg-muted border-none bg-transparent hover:bg-black/0 underline text-[#5577B9] hover:text-[#5577B9]/60 text-sm"
      >
        Avaliar
      </Button>
    </div>
  );
}
